/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_Li3Inputs */

const en_about_section2_li3 = /** @type {(inputs: About_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free & Open Source: No subscriptions, no paywalls, no feature restrictions. The source code is available on GitHub.`)
};

const ko_about_section2_li3 = /** @type {(inputs: About_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 & 오픈 소스: 구독, 페이월, 기능 제한이 없습니다. 소스 코드는 GitHub에서 이용 가능합니다.`)
};

const ja_about_section2_li3 = /** @type {(inputs: About_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料＆オープンソース：サブスクリプション、ペイウォール、機能制限なし。ソースコードはGitHubで利用可能です。`)
};

/**
* | output |
* | --- |
* | "Free & Open Source: No subscriptions, no paywalls, no feature restrictions. The source code is available on GitHub." |
*
* @param {About_Section2_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_li3 = /** @type {((inputs?: About_Section2_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_li3(inputs)
	if (locale === "ko") return ko_about_section2_li3(inputs)
	return ja_about_section2_li3(inputs)
});